import Personalia from '../../../views/Personnel/Payroll/Personalia.payroll.view';

export default Personalia;
